import { Descriptions, Empty } from 'antd';

import { IWebPunchLink } from '../../../../api/interfaces/support/webpunch';
import { useTranslate } from '../../../../hooks/translate';

type Props = {
  webpunch?: IWebPunchLink;
};

const UpdatedWebpunch = ({ webpunch }: Props) => {
  const { t } = useTranslate();

  if (!webpunch || !('id' in webpunch)) {
    return <Empty description={t('support.nglink.noData')} />;
  }

  return (
    <Descriptions title={t('support.nglink.updatedWebpunch')} column={1}>
      <Descriptions.Item label={t('support.nglink.virksIdLabel')}>
        {webpunch.foreignId}
      </Descriptions.Item>
      <Descriptions.Item label={t('common.id')}>
        {webpunch.id}
      </Descriptions.Item>
      <Descriptions.Item label={t('support.nglink.keyType')}>
        {webpunch.keyType}
      </Descriptions.Item>
      <Descriptions.Item label={t('support.nglink.localId')}>
        {webpunch.localId}
      </Descriptions.Item>
      <Descriptions.Item label={t('support.nglink.restIdLabel')}>
        {webpunch.restId}
      </Descriptions.Item>
      <Descriptions.Item label={t('support.nglink.timestamp')}>
        {webpunch.ts}
      </Descriptions.Item>
    </Descriptions>
  );
};

export default UpdatedWebpunch;
